import { render, staticRenderFns } from "./DashboardDetailFlow.vue?vue&type=template&id=9a713f7e&"
import script from "./DashboardDetailFlow.vue?vue&type=script&lang=js&"
export * from "./DashboardDetailFlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a713f7e')) {
      api.createRecord('9a713f7e', component.options)
    } else {
      api.reload('9a713f7e', component.options)
    }
    module.hot.accept("./DashboardDetailFlow.vue?vue&type=template&id=9a713f7e&", function () {
      api.rerender('9a713f7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/vistas/dashboard/DashboardDetailFlow.vue"
export default component.exports